import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyDEwqWuV-X_Kr1j4kbbk45k8U30C9b57OA",
  authDomain: "wealth-vision-ai.firebaseapp.com",
  projectId: "wealth-vision-ai",
  storageBucket: "wealth-vision-ai.firebasestorage.app",
  messagingSenderId: "627817511653",
  appId: "1:627817511653:web:13aed83f2a005618c7320c",
  measurementId: "G-KVLYCCKC3W"
};

// Check if we're in a browser environment (not during SSR/pre-rendering)
const isBrowser = typeof window !== 'undefined';

// Initialize Firebase only in browser environment
const app = isBrowser ? initializeApp(firebaseConfig) : null;

// Initialize Firebase services only in browser environment
// Use null-safe exports to prevent errors during pre-rendering
export const auth = isBrowser ? getAuth(app) : null;
export const db = isBrowser ? getFirestore(app) : null;
export const functions = isBrowser ? getFunctions(app) : null;
export const googleProvider = isBrowser ? new GoogleAuthProvider() : null;

export default app;
